import styled from 'styled-components';

export const BookingSearchOnHoldResultsHeader = styled.div`
  @media (min-width: 700px) {
    display: flex;

    > * {
      flex: 1;
    }
  }
`;
